/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Ré-assureur transmis à la création/modification d'une garantie. Clés PascalCase imposées par le back.
 * @export
 * @interface ReAssureurCommandDto
 */
export interface ReAssureurCommandDto {
    /**
     * Compagnie ré-assureur (PersonneMorale de nature CIE).
     * @type {string}
     * @memberof ReAssureurCommandDto
     */
    reAssureurPersonneMoraleId: string;
    /**
     * 
     * @type {string}
     * @memberof ReAssureurCommandDto
     */
    compteBancaireId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReAssureurCommandDto
     */
    tauxQP?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReAssureurCommandDto
     */
    xS?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ReAssureurCommandDto
     */
    porteeXS?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReAssureurCommandDto
     */
    attachementXS?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReAssureurCommandDto
     */
    qP?: boolean;
}

/**
 * Check if a given object implements the ReAssureurCommandDto interface.
 */
export function instanceOfReAssureurCommandDto(value: object): value is ReAssureurCommandDto {
    if (!('reAssureurPersonneMoraleId' in value) || value['reAssureurPersonneMoraleId'] === undefined) return false;
    return true;
}

export function ReAssureurCommandDtoFromJSON(json: any): ReAssureurCommandDto {
    return ReAssureurCommandDtoFromJSONTyped(json, false);
}

export function ReAssureurCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReAssureurCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'reAssureurPersonneMoraleId': json['reAssureurPersonneMoraleId'],
        'compteBancaireId': json['compteBancaireId'] == null ? undefined : json['compteBancaireId'],
        'tauxQP': json['tauxQP'] == null ? undefined : json['tauxQP'],
        'xS': json['XS'] == null ? undefined : json['XS'],
        'porteeXS': json['PorteeXS'] == null ? undefined : json['PorteeXS'],
        'attachementXS': json['AttachementXS'] == null ? undefined : json['AttachementXS'],
        'qP': json['QP'] == null ? undefined : json['QP'],
    };
}

export function ReAssureurCommandDtoToJSON(json: any): ReAssureurCommandDto {
    return ReAssureurCommandDtoToJSONTyped(json, false);
}

export function ReAssureurCommandDtoToJSONTyped(value?: ReAssureurCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reAssureurPersonneMoraleId': value['reAssureurPersonneMoraleId'],
        'compteBancaireId': value['compteBancaireId'],
        'tauxQP': value['tauxQP'],
        'XS': value['xS'],
        'PorteeXS': value['porteeXS'],
        'AttachementXS': value['attachementXS'],
        'QP': value['qP'],
    };
}

